import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const Settings = () => {
    document.title = "Ayarlar";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Kassa", value: "/cash" },
        { name: "Ayarlar", value: "/cash/settings", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <h2 className="my-4">Kassa</h2>
                <div className="row g-4">
                    <div className="col-6">
                        <Link to={"admin"}>Admin</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"check"}>Çek</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"fiscal"}>Fiskal çek</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"product"}>Məhsul</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"customergroups"}>Müştəri qrupları</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"security"}>Təhlükəsizlik</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};
